import { Injectable } from '@angular/core';

@Injectable()
export class TechnicalTermDomain {
    constructor() { }

    destroy(): void {

    }
}
